export default __webpack_public_path__ + "static/media/menu-bg.8fb950d6.webp";